"use client";

import { ColorVariant, TCarEquityCtaSection } from "@shared/types";
import { HeroButton, HighlightText } from "@shared/ui";
import Image from "next/image";

export function CarEquityCtaSection({
  title,
  highlightedTitle,
  highlightedTitleColor,
  description,
  image,
  button,
  items,
}: TCarEquityCtaSection) {
  return (
    <div
      className="relative text-white overflow-hidden"
      style={{
        background: "radial-gradient(79.52% 59.78% at 61.12% 71.69%, #3F92AC 0%, #285D6E 45.51%, #1A3B46 93.52%)",
      }}
    >
      <div className="container relative">
        <div className="lg: h-full flex flex-col justify-center py-14 xl:py-20 relative lg:w-[38%]">
          <h3 className="text-4xl sm:text-5xl lg:text-6xl font-bold !leading-[112%]">
            <HighlightText text={title || "CTA"} highlight={highlightedTitle || ""} highlightColor={highlightedTitleColor} />
          </h3>
          {description && <p className="mt-8 text-xl md:text-2xl w-[80%]">{description}</p>}
          {items && items.length > 0 && (
            <div className="mt-8 space-y-4 text-lg md:text-xl">
              {items.map((item) => {
                return (
                  <div className="flex items-center gap-3" key={item.id}>
                    {item.icon && item.icon?.data && (
                      <Image
                        src={item.icon.data?.attributes?.url || ""}
                        width={item.icon.data?.attributes?.width || 28}
                        height={item.icon.data?.attributes?.height || 28}
                        alt={item.icon.data?.attributes?.alternativeText || item.icon.data?.attributes?.name}
                        className="size-7 min-w-7"
                      />
                    )}
                    {item.title}
                  </div>
                );
              })}
            </div>
          )}
          {button && (
            <div className="mt-10">
              <HeroButton
                target={button.target}
                link={button.href}
                variant={button.variant as ColorVariant}
                linkText={button.text}
                linkIcon={button.icon}
                hideShine
              />
            </div>
          )}
        </div>
        {image && image.data && (
          <div className="w-full max-w-[1024px] max-h-[780px] relative lg:absolute lg:bottom-0 lg:right-0 -mx-4 lg:h-full lg:w-[65%]">
            <Image
              src={image?.data?.attributes?.url || ""}
              alt={image?.data?.attributes?.alternativeText || image?.data?.attributes?.name || ""}
              width={image?.data?.attributes?.width || 1000}
              height={image?.data?.attributes?.height || 1000}
              className="object-bottom h-full w-auto object-contain"
            />
          </div>
        )}
      </div>
    </div>
  );
}
